import PaymentAccountHandler from '@portal/pages/PaymentAccount/PaymentAccountHandler';
import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import AuthNavigationStack from '~/pages/Auth/AuthNavigationStack';
import PendingDocumentsNavigator from '~/pages/PendingDocuments/PendingDocumentsNavigator';

import { onboarding } from '@portal/config/app.json';
import { getRouteStackPath } from '@portal/config/routes';
import useReduxState from '@portal/hooks/useReduxState';
import { AccountStatus } from '@portal/models/enumerators';
import Campaign from '@portal/pages/Campaign/Campaign';
import { history } from '@portal/services/browserHistory';
import { OperatorStatus } from './app/enum/accountStatus';
import CreateInCoreBank from './app/pages/Home/CreateInCoreBank/CreateInCoreBank';

const RouterApp = () => {
  const {
    auth: {
      authToken: { accessToken },
    },
    user: {
      me: user,
      pendingDocuments,
      needCreateInCoreBank,
      me: { operatorStatus },
    },
  } = useReduxState();

  const shouldShowAuthStack = () => {
    const currentPath = window.location.pathname;
    const accountSelectionPath = getRouteStackPath(
      'PROFILE',
      'ACCOUNT_SELECTION'
    );

    if (currentPath === accountSelectionPath) {
      return true;
    }

    return (
      !accessToken ||
      !user.id ||
      !pendingDocuments ||
      (pendingDocuments && pendingDocuments.length > 0) ||
      user.account.status !== AccountStatus.APPROVED
    );
  };

  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/documentos-pendentes">
          <PendingDocumentsNavigator />
        </Route>

        {needCreateInCoreBank ||
        (operatorStatus && operatorStatus !== OperatorStatus.LINKED) ? (
          <Route exact path="/confirmar-conta">
            <CreateInCoreBank />
          </Route>
        ) : null}

        {onboarding?.memberGetMemberCampaignPage ? (
          <Route exact path="/campanha/:id">
            <Campaign />
          </Route>
        ) : null}

        <Route path="/">
          {shouldShowAuthStack() ? (
            <AuthNavigationStack />
          ) : (
            <PaymentAccountHandler />
          )}
        </Route>
      </Switch>
    </Router>
  );
};

export default RouterApp;
